import React from 'react';
import { Layout } from '../components/common';
import { 
  HeroSection, 
  MissionSection, 
  FeaturesSection, 
  CommitmentSection, 
  CTASection 
} from '../components/home';

const HomePage: React.FC = () => {
  return (
    <Layout>
      <HeroSection />
      <MissionSection />
      <FeaturesSection />
      <CommitmentSection />
      <CTASection />
    </Layout>
  );
};

export default HomePage;